import { Component, Inject, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { finalize, map, Observable } from 'rxjs';
import { VendorService } from '../../services/vendor-service';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatTableModule } from '@angular/material/table';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatSpinner } from '@angular/material/progress-spinner';


@Component({
  selector: 'app-download-attachments',
  standalone: true,
  imports: [
    CommonModule,
    MatCardModule,    
    MatTableModule,
    MatDialogModule, MatButtonModule, MatIconModule,MatSpinner
  ],
  templateUrl: './download-attachments.component.html',
  styleUrl: './download-attachments.component.css'
})
export class DownloadAttachmentsComponent {
  isLoading = false;
  attachments$!: Observable<any[]>;
  constructor(private route: ActivatedRoute, private vendorService: VendorService,public dialogRef: MatDialogRef<DownloadAttachmentsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { purchase_id: number ,name:string,type:string}) { }
  displayedColumns: string[] = [
    'slno',  
    // 'file1',
    'file1_name',
    'file1_status',
    'file1_remarks',
    // 'file2',
    'file2_name',   
    'file2_status',
    'file2_remarks'
  ];
  ngOnInit() {   
    this.getAttachments();
    console.log('this.orderDetails$',this.attachments$);    
  }

  getAttachments() {    
    this.isLoading = true;
    this.attachments$ = this.vendorService.getUploadFiles(Number(this.data.purchase_id),this.data.type).pipe(
      map((res: any) => res.result.attachments),
       finalize(() => this.isLoading = false)
    );
  }

   onCancel() {
    this.dialogRef.close();
  }
//  downloadBinary(fileData: ArrayBuffer | Uint8Array<ArrayBufferLike>, fileName: string) {
//   if (!fileData) return;

//   let blob: Blob;

//   if (fileData instanceof ArrayBuffer) {
//     // Explicit cast to ArrayBuffer
//     blob = new Blob([fileData as ArrayBuffer]);
//   } else if (fileData instanceof Uint8Array) {
//     // Convert to real ArrayBuffer (not SharedArrayBuffer)
//     const buffer = fileData.buffer as ArrayBuffer;
//     blob = new Blob([buffer]);
//   } else {
//     console.error('Unsupported file data type', fileData);
//     return;
//   }

//   this.triggerDownload(blob, fileName);
// }

downloadBase64File(base64Data: string, fileName: string) {
  if (!base64Data) {
    console.error("No file data to download");
    return;
  }

  try {
    const byteCharacters = atob(base64Data);
    const byteNumbers = new Array(byteCharacters.length);

    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: this.getMimeType(base64Data) });

    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = fileName || "download";
    a.click();
    window.URL.revokeObjectURL(url);
  } catch (err) {
    console.error("Failed to decode Base64 file", err);
  }
}

private getMimeType(base64: string): string {
  // Check magic numbers for file type detection
  if (base64.startsWith("JVBERi0")) return "application/pdf"; // PDF
  if (base64.startsWith("iVBORw0")) return "image/png";        // PNG
  if (base64.startsWith("/9j/")) return "image/jpeg";           // JPG
  return "application/octet-stream"; // fallback
}


private triggerDownload(blob: Blob, fileName: string) {
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = fileName || 'download';
  a.click();
  window.URL.revokeObjectURL(url);
}




}

